import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const ILoadingBar = ({ size = 120, isLoading = false }) => (
  <div
    style={{
      position: "fixed",
      display: isLoading ? "flex" : "none",
      top: 0,
      left: 0,
      width: "100%",
      height: "100vh",
      justifyContent: "center",
      alignItems: "center",
      pointerEvents: "none",
    }}
  >
    <CircularProgress size={size} />
  </div>
);

export default ILoadingBar;
